// [APP-FORK] 앱 스토어 URL 공용 상수. QR 랜딩(AppLinkLanding)과 claim 인앱가드
//  (AppOnlyGuard)의 "앱 설치하기" 유도가 같은 값을 쓰도록 한 곳에서 관리한다.
//  ★스토어 등록 후 아래 두 값만 채우면 앱 설치 유도가 자동 활성화된다(빈 문자열이면 "준비중").

export const ANDROID_STORE =
  'https://play.google.com/store/apps/details?id=com.naegift.app';
export const IOS_STORE = 'https://apps.apple.com/kr/app/id6791131122';

// 현재 OS 에 맞는 스토어 URL. 안드로이드/iOS 외(데스크탑 등)는 빈 문자열 → 호출부에서 "준비중" 처리.
export const storeUrlForOs = (): string => {
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
  if (/android/i.test(ua)) return ANDROID_STORE;
  if (/iphone|ipad|ipod/i.test(ua)) return IOS_STORE;
  return '';
};
